import React from 'react';
import { useLocation } from 'react-router-dom';
import { parse } from 'query-string';
import Accepting from './Accepting/Accepting';
import NotFound from 'components/NotFound/NotFound';

function UserAcceptInvitation() {
  const { search } = useLocation();
  const { userID, instanceID } = parse(search);

  if (!userID || typeof userID !== 'string') {
    return <NotFound />;
  }

  if (!instanceID || typeof instanceID !== 'string') {
    return <NotFound />;
  }

  return <Accepting userID={userID} instanceID={instanceID} />;
}

export default UserAcceptInvitation;
